import { render } from "./StudentTempManage.vue?vue&type=template&id=18feee20&scoped=true"
import script from "./StudentTempManage.vue?vue&type=script&lang=js"
export * from "./StudentTempManage.vue?vue&type=script&lang=js"

import "./StudentTempManage.vue?vue&type=style&index=0&id=18feee20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18feee20"]])

export default __exports__